<form [formGroup]="submissionDetailsForm" class="w-full overflow-x-hidden overflow-y-auto max-h-[calc(65vh-15px)]">

  <!-- General Details Section -->
  <div class="w-full flex flex-col items-start justify-start mt-5 mb-4 px-7">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2">General Details</p>

    <div class="flex flex-row flex-wrap items-center gap-x-1 text-[13px] mb-4">
      <span class="font-bold text-[var(--base-text-alt-dark)]">Rep/Agent Name:</span>
      <span class="font-medium text-[var(--primary-dark)]" *ngIf="labSubmissionDetails?.creationUserId">{{ labSubmissionDetails?.creationUserName + ' ' + labSubmissionDetails?.creationUserSurname }}</span>
      <span class="mx-2.5 text-[var(--tertiary-text)]">|</span>
      <span class="font-bold text-[var(--base-text-alt-dark)]">Date Created:</span>
      <span class="font-medium text-[var(--primary-dark)] ml-1">{{creationDate | date: 'yyyy-MM-dd'}}</span>
      <span class="mx-2.5 text-[var(--tertiary-text)]">|</span>
      <span class="font-bold text-[var(--base-text-alt-dark)]">Lab Submission Type:</span>
      <span class="font-medium text-[var(--primary-dark)] ml-1">{{submissionTypes.length > 0 && labSubmissionDetails?.labManTypesId ? submissionTypes[labSubmissionDetails.labManTypesId - 1].description : '-'}}</span>
    </div>

    <section class="w-full flex flex-wrap items-start gap-x-4">
      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Agronomist</mat-label>
          <mat-select formControlName="agronomistUserId">
            <mat-option style="background-color: white!important; padding: 6px!important;">
              <div class="flex justify-center">
                <ngx-mat-select-search placeholderLabel="Search Agronomist" [formControl]="agronomistFilterCtrl">
                  <span ngxMatSelectNoEntriesFound>No entries found</span>
                </ngx-mat-select-search>
              </div>
            </mat-option>
            <mat-option *ngFor="let agronomist of filteredAgronomistList | orderBy: 'userIdName'" [value]="agronomist.userIdId">
              {{agronomist?.userIdName + ' ' + agronomist?.userIdSurname}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Lab</mat-label>
          <mat-select formControlName="labManLabId" [disabled]="hasOneAnalysis">
            <mat-option *ngFor="let lab of labList" [value]="lab.id">
              {{lab?.description}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Agent Lab Ref.Number</mat-label>
          <input matInput formControlName="agentLabRef" maxlength="25">
        </mat-form-field>
      </div>
    </section>
  </div>

  <div class="h-px bg-[var(--app-base)]"></div>

  <!-- Customer Details Section -->
  <div class="w-full flex flex-col items-start justify-start mt-5 mb-4 px-7">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2">Customer Details</p>

    <section class="w-full flex flex-col items-start">
      <div class="w-full flex flex-row flex-wrap items-center">
        <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
          <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
            <mat-label appRemoveAriaOwns>Client</mat-label>
            <mat-select [disabled]="labSubmissionDetails?.labManStatusId === 1 || hasOneSample" matInput formControlName="otcCustomerDetailId">
              <mat-option style="background-color: white!important; padding: 6px!important;">
                <div class="flex justify-center">
                  <ngx-mat-select-search placeholderLabel="Search Client" [formControl]="clientFilterCtrl">
                    <span ngxMatSelectNoEntriesFound>No entries found</span>
                  </ngx-mat-select-search>
                </div>
              </mat-option>
              <mat-option (click)="clientDetailChanged()" *ngFor="let customer of filteredClientList | orderBy: 'name'" [value]="customer.id">
                {{customer?.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
          <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
            <mat-label appRemoveAriaOwns>Contact Person</mat-label>
            <input matInput formControlName="contactPerson" maxlength="30">
          </mat-form-field>
        </div>

        <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
          <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
            <mat-label appRemoveAriaOwns>Contact Number</mat-label>
            <input matInput formControlName="contactNumber" maxlength="13">
          </mat-form-field>
        </div>
      </div>

      <div class="flex flex-row items-start mt-2 mb-4">
        <div class="flex flex-col justify-center w-[120px]">
          <p class="text-[13px] font-bold mb-1">Address:</p>
          <p class="text-[13px] font-bold mb-1">Town:</p>
          <p class="text-[13px] font-bold mb-1">Code:</p>
        </div>
        <div class="flex flex-col ml-2">
          <p class="text-[13px] mb-1">{{ selectedCustomer?.address?.addressLine1 ?? '-' }}</p>
          <p class="text-[13px] mb-1">{{ selectedCustomer?.address?.town ?? '-' }}</p>
          <p class="text-[13px] mb-1">{{ selectedCustomer?.address?.postalCode ?? '-' }}</p>
        </div>
      </div>
    </section>
  </div>

  <div class="h-px bg-[var(--app-base)]"></div>

  <!-- Order Details Section -->
  <div class="w-full flex flex-col items-start justify-start mt-5 mb-4 px-7">
    <p class="text-[16px] font-bold text-[var(--base-text-alt-dark)] mb-2">Order Details</p>

    <section class="w-full flex flex-wrap items-start gap-x-4">
      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Account (Payer)</mat-label>
          <mat-select formControlName="orderAccountId">
            <mat-option style="background-color: white!important; padding: 6px!important;">
              <div class="flex justify-center">
                <ngx-mat-select-search placeholderLabel="Search Payer" [formControl]="payerFilterCtrl">
                  <span ngxMatSelectNoEntriesFound>No entries found</span>
                </ngx-mat-select-search>
              </div>
            </mat-option>
            <mat-option (onSelectionChange)="checkCoOp(customer)" *ngFor="let customer of filteredPayerList | orderBy: 'name'" [value]="customer.id">
              {{customer?.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="checkPayerType()" class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>CO-OP Order Number</mat-label>
          <input matInput formControlName="coopNo" maxlength="25">
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Order Date</mat-label>
          <input matInput [max]="currentDate" [matDatepicker]="picker1" formControlName="orderDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
          <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Courier</mat-label>
          <input matInput formControlName="courier" maxlength="25">
        </mat-form-field>
      </div>

      <div class="w-full max-w-[420px] min-w-[300px] h-[80px] flex items-center">
        <mat-form-field class="w-full max-w-[calc(100%-30px)] min-w-[280px]" appearance="outline">
          <mat-label appRemoveAriaOwns>Waybill No.</mat-label>
          <input matInput formControlName="waybillNumber" maxlength="25">
        </mat-form-field>
      </div>
    </section>

    <div class="w-full max-w-[36%] min-w-[300px] mb-6">
      <p class="text-[13px] font-semibold text-[var(--base-text-alt-dark)] mb-1">Notes/Comments</p>
      <textarea formControlName="note"
        class="border border-[var(--app-border)] bg-transparent w-full min-w-[220px] h-[140px] p-2 text-[12px] font-semibold text-[var(--base-text-alt-dark)] resize-none rounded"></textarea>
    </div>
  </div>

  <div class="h-px bg-[var(--app-base)]"></div>

</form>
